import Button from "@/components/Button";
import CheckBox from "@/components/Checkbox";
import DatePick from "@/components/DatePicker";
import Dropdown from "@/components/Dropdown";
import Input from "@/components/Input";
import Modal from "@/components/Modal";
import TextArea from "@/components/TextArea";
import React from "react";

interface PropsModalDetail {
  showModalDetail: boolean;
  setShowModalDetail: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
}

const ModalDetail = (props: PropsModalDetail) => {
  const { showModalDetail, setShowModalDetail, data } = props;

  const getSelectedType = (type: number) => {
    switch (type) {
      case 1:
        return { label: "Announcement", value: 1 };
      case 2:
        return { label: "Live Streaming", value: 2 };
      case 3:
        return { label: "Product Release", value: 3 };
    }
  };
  return (
    <Modal
      setIsOpen={() => setShowModalDetail(!showModalDetail)}
      type="notification"
      title="View Notification"
      subtitle="View Notification description"
      withDevider
      content={
        <div className="modal-content">
          <div className="row">
            <div className="label">
              <span>
                Type<span>*</span>
              </span>
            </div>
            <div className="input">
              <Dropdown
                placeHolder="Select Type"
                value={getSelectedType(data?.type)}
                options={[
                  { label: "Announcement", value: 1 },
                  { label: "Live Streaming", value: 2 },
                  { label: "Product Release", value: 3 },
                ]}
                onChange={(e: any) => null}
                disabled
                optionType="text-option"
                width="400px"
              />
            </div>
          </div>
          <div className="divider" />
          <div className="row">
            <div className="label">
              <span>
                Title<span>*</span>
              </span>
            </div>
            <div className="input">
              <TextArea
                value={data?.title}
                style={{ width: "400px", height: "68px" }}
                maxLength={100}
                withCounter={false}
                onChange={(e) => null}
                disabled
                placeholder="e.g. Apakah kamu pemenangnya? Segera di mulai, pengumuman GIVEAWAY MOTOR dari DRX!  🏍"
              />
            </div>
          </div>
          <div className="divider" />
          <div className="row">
            <div className="label">
              <span>
                Image<span>*</span>
              </span>
            </div>
            <div className="input">
              <img
                style={{ borderRadius: "4px", backgroundSize: "cover" }}
                src={`${process.env.REACT_APP_API_URL}/file/${data?.media}`}
                alt="Notification"
                width={"400px"}
                height={"174px"}
              />
            </div>
          </div>
          <div className="divider" />
          <div className="row">
            <div className="label">
              <span>Link</span>
            </div>
            <div className="input">
              <Input
                style={{ width: "400px" }}
                type="text"
                withIcon={false}
                placeholder=""
                value={data?.link ?? "-"}
                disabled
                onChange={(e) => null}
              />
            </div>
          </div>
          <div className="divider" />
          <div className="row">
            <div className="label">
              <span>
                Publish Date<span>*</span>
              </span>
            </div>
            <div className="input">
              <div className="column">
                <div className="row margin-bt">
                  <div className="checkbox">
                    <CheckBox
                      checked={!data?.is_scheduled}
                      disabled
                      onChange={() => null}
                    />
                  </div>
                  <span className="text">Publish now</span>
                </div>
                <DatePick
                  style={{ width: "400px" }}
                  placeholder="Select date"
                  value={new Date(data?.scheduled_at)}
                  onChange={(e) => null}
                  disabled
                  withTime
                />
              </div>
            </div>
          </div>
        </div>
      }
      footer={
        <div className="modal-footer">
          <Button
            style={{ width: "270px" }}
            type="secondary"
            label="Cancel"
            onClick={() => setShowModalDetail(!showModalDetail)}
          />
          <Button
            style={{ width: "270px" }}
            type="primary"
            label="Save"
            disabled
            onClick={() => null}
          />
        </div>
      }
    />
  );
};

export default ModalDetail;
